document.addEventListener("DOMContentLoaded", function () {
    const stickyBox = document.getElementById("StickyBuyBox");

    if (!stickyBox) return;

    const scrollThreshold = 800; // 400pxスクロールしたら表示開始

    // スクロールイベントでスクロール量を監視
    window.addEventListener("scroll", function () {
        if (window.scrollY > scrollThreshold) {
            // 400px以上スクロールしたら表示
            stickyBox.classList.remove("hidden");
        } else {
            // 400px未満のスクロールでは非表示
            stickyBox.classList.add("hidden");
        }
    });

    // 初期状態では非表示
    stickyBox.classList.add("hidden");
});
